import React from 'react';
import { BookingButton } from '../components/BookingButton';
import { ProviInfographic } from '../components/ProviInfographic';
import { FooterCTA } from '../components/FooterCTA';
export function About() {
  return <div className="w-full min-h-screen bg-[#F1F5F9] overflow-x-hidden pt-20" data-id="element-178" data-mp="29kolnpigo0xx">
      {/* SECTION 1 — HERO DESPRE MINE */}
      <section className="w-full bg-[#09111F] relative overflow-hidden py-16 md:py-24" data-id="element-179" data-mp="2ej859j9l10n4">
        <div className="absolute inset-0 opacity-[0.03] bg-[radial-gradient(#ffffff_1px,transparent_1px)] [background-size:24px_24px]" data-id="element-180" data-mp="329m1llz79lni"></div>
        <div className="max-w-[1200px] mx-auto px-5 md:px-12 relative z-10" data-id="element-181" data-mp="3751bk2u36xen">
          <div className="grid md:grid-cols-2 gap-12 items-center" data-id="element-182" data-mp="2s9v3zbfceqj7">
            <div className="text-center" data-id="element-183" data-mp="2x86dtm5n111f">
              <div className="inline-flex items-center gap-2 bg-[rgba(255,255,255,0.03)] border border-[rgba(255,255,255,0.08)] backdrop-blur-sm px-4 py-2 rounded-full mb-6 mx-auto" data-id="element-184" data-mp="2xb10lkc4ixy0">
                <span className="font-['Montserrat'] text-[11px] font-bold tracking-[0.18em] uppercase text-[#3B82F6]" data-id="element-185" data-mp="1lvcf6xeiq6zb">
                  IMPLEMENTARE SISTEME DE BUSINESS
                </span>
              </div>
              <h1 className="font-['Montserrat'] text-[clamp(40px,5vw,64px)] font-extrabold text-white leading-[1.1] mb-4" style={{
              textAlign: "center"
            }} data-id="element-186" data-mp="1pl1poi4zo1ri">
                Valer Dura
              </h1>
              <p className="font-['Montserrat'] text-[18px] font-semibold text-[#3B82F6] mb-8" style={{
              textAlign: "center"
            }} data-id="element-187" data-mp="1ylq3bbqh003v">
                Fondator PROVI System . Arhitect de Sisteme Antreprenoriale
                Scalabile & Vandabile .
              </p>
              <p className="font-['Inter'] text-[20px] font-light text-[rgba(255,255,255,0.8)] leading-[1.8] italic" style={{
              textAlign: "center"
            }} data-id="element-188" data-mp="2m7oaj4h1q0z9">
                "Nu vin să îți spun ce să faci. Vin în compania ta, lucrez cu
                oamenii tăi și construiesc, alături de tine, sistemul care face
                afacerea să meargă fără să fii tu prezent în fiecare zi."
              </p>
            </div>
            <div className="relative" data-id="element-189" data-mp="1owhbtcdhjkrs">
              <div className="absolute inset-0 bg-[#1D4ED8] opacity-20 blur-[60px] rounded-full" data-id="element-190" data-mp="1svyi280qkly0"></div>
              <img src="https://cdn.magicpatterns.com/uploads/gPL9PGEUfU86kwxwuhzswi/Valer_Dura_-_Poza_Pagina_Despre_Mine.png" alt="Valer Dura" className="relative z-10 w-full max-w-[450px] mx-auto rounded-2xl border-2 border-[rgba(255,255,255,0.1)] shadow-2xl" data-id="element-191" data-mp="1xut0v9ypeai4" />
            </div>
          </div>
        </div>
      </section>

      {/* SECTION 2 — DE CE FAC CE FAC */}
      <section className="w-full bg-white py-16 md:py-24" data-id="element-192" data-mp="2cmblxm6f6v8c">
        <div className="max-w-[800px] mx-auto px-5 md:px-12 text-center" data-id="element-193" data-mp="2gn3zgrmbrmaf">
          <h2 className="font-['Montserrat'] text-[32px] md:text-[40px] font-bold text-[#09111F] mb-8" data-id="element-194" data-mp="2llf8j04spsrl">
            De ce am ales să lucrez cu antreprenorii
          </h2>
          <div className="space-y-6 font-['Inter'] text-[19px] font-light text-[#4B5563] leading-[1.8] text-left" data-id="element-195" data-mp="ma5o04ow2jli">
            <p data-id="element-196" data-mp="jn3fvqxu3882">
              Am construit companii de la zero. Am ajuns la cifre de milioane.
              Am făcut exit. Și știu exact cum se simte să fii cel mai obosit om
              din firma ta, să iei toate deciziile, să rezolvi toate problemele
              și să îți spui în fiecare seară că mâine va fi altfel.
            </p>
            <p className="font-medium text-[#09111F]" data-id="element-197" data-mp="4zs69ul7pyal">
              Nu a fost altfel până nu am pus un sistem în locul improvizației.
            </p>
            <p data-id="element-198" data-mp="xne5kqneqgrn">
              Azi fac pentru alți antreprenori ceea ce mi-aș fi dorit eu să facă
              cineva pentru mine: vin cu echipa mea, implementăm PROVI System
              direct în compania ta și nu plecăm până când afacerea nu merge
              fără tine.
            </p>
          </div>
        </div>
      </section>

      {/* SECTION 4 — MISIUNEA MEA */}
      <section className="w-full bg-[#0A1628] py-16 md:py-24 text-white" data-id="element-199" data-mp="3dc630taxdcjw">
        <div className="max-w-[1000px] mx-auto px-5 md:px-12" data-id="element-200" data-mp="39b42881d0sft">
          <h2 className="font-['Montserrat'] text-[32px] md:text-[40px] font-bold text-center mb-12" data-id="element-201" data-mp="113h5nvgsirzo">
            De ce există PROVI System
          </h2>
          <div className="grid md:grid-cols-3 gap-6 mb-16" data-id="element-202" data-mp="15wse21193gtp">
            <div className="bg-[rgba(255,255,255,0.05)] border border-[rgba(255,255,255,0.1)] rounded-2xl p-6 text-center" data-id="element-203" data-mp="r6ui2yx2xmty">
              <p className="font-['Inter'] text-[17px] font-light" data-id="element-204" data-mp="w55the30w5ea">
                Din antreprenor captiv în firmă, la{' '}
                <strong className="font-semibold text-[#3B82F6]" data-id="element-205" data-mp="1jsnlnaq795hs">
                  fondator liber
                </strong>
                .
              </p>
            </div>
            <div className="bg-[rgba(255,255,255,0.05)] border border-[rgba(255,255,255,0.1)] rounded-2xl p-6 text-center" data-id="element-206" data-mp="1atitqn958ael">
              <p className="font-['Inter'] text-[17px] font-light" data-id="element-207" data-mp="3vk12h0npir80">
                Din companie dependentă de om, la{' '}
                <strong className="font-semibold text-[#3B82F6]" data-id="element-208" data-mp="3gqhl0f6u376">
                  business care merge singur
                </strong>
                .
              </p>
            </div>
            <div className="bg-[rgba(255,255,255,0.05)] border border-[rgba(255,255,255,0.1)] rounded-2xl p-6 text-center" data-id="element-209" data-mp="3n393sm38a9cb">
              <p className="font-['Inter'] text-[17px] font-light" data-id="element-210" data-mp="5tu9or8gxmnf">
                Din stagnare și plafonare, la{' '}
                <strong className="font-semibold text-[#3B82F6]" data-id="element-211" data-mp="wbzyymmn3ed">
                  creștere predictibilă și garantată
                </strong>
                .
              </p>
            </div>
          </div>
          <div className="space-y-6 font-['Inter'] text-[19px] font-light text-[rgba(255,255,255,0.8)] leading-[1.8]" data-id="element-212" data-mp="34ec94h3x5etk">
            <p data-id="element-213" data-mp="3j38iqilmizwa">
              După ce am construit, eficientizat și vandut propriile afaceri,
              m-am dedicat către lucrul cu antreprenorii care își doresc de la
              afacerile lor, fix ce mi-am dorit eu la început: timp, libertate
              și bani.
            </p>
            <p data-id="element-214" data-mp="2ljx7sku4xa2k">
              Lucrez cu antreprenori mici și mijlocii care au construit o
              afacere ce merge, dar nu merge fără ei în centrul fiecărei
              decizii.
            </p>
            <p data-id="element-215" data-mp="3f9e7h8cdojh5">
              Prin PROVI System, implementam în compania lor cele 8 componente
              care transformă improvizația în sistem, dependența în autonomie și
              plafonul în creștere.
            </p>
            <p className="text-white font-medium" data-id="element-216" data-mp="2sbt3sfilr7oy">
              Prin legea cauzei și efectului, dacă facem ce trebuie să facem,
              rezultatele vin de fiecare dată. Nu există dubiu. Există doar
              sistem și execuție.
            </p>
          </div>
        </div>
      </section>

      {/* SECTION 5 — ACREDITĂRI & FORMARE PROFESIONALĂ */}
      <section className="w-full bg-white py-16 md:py-24" data-id="element-217" data-mp="368zju2bxysah">
        <div className="max-w-[800px] mx-auto px-5 md:px-12" data-id="element-218" data-mp="gkp55qzweotv">
          <div className="text-center mb-12" data-id="element-219" data-mp="lkuz5dtn4nf4">
            <h2 className="font-['Montserrat'] text-[32px] md:text-[40px] font-bold text-[#09111F] mb-6" data-id="element-220" data-mp="ljjxbjjr9pqn">
              Formare & Experiență
            </h2>
            <p className="font-['Inter'] text-[19px] font-light text-[#6B7280] max-w-[800px] mx-auto" data-id="element-221" data-mp="2142q4mk981q9">
              Dincolo de diplome, cel mai important activ al meu este experiența
              de a fi construit, condus și vândut companii reale, cu cifre
              reale, în România.
            </p>
          </div>
          <div className="flex flex-col gap-4" data-id="element-222" data-mp="1nco3m5r51ieg">
            {[{
            text: 'Specialist în Activitatea de Coaching',
            why: 'Pun întrebările care scot la suprafață problema reală, nu simptomul pe care mi-l descrii — așa nu pierzi luni de zile rezolvând lucrul greșit.',
            icon: 'M12 14l9-5-9-5-9 5 9 5z M12 14l6.16-3.422a12.083 12.083 0 01.665 6.479A11.952 11.952 0 0012 20.055a11.952 11.952 0 00-6.824-2.998 12.078 12.078 0 01.665-6.479L12 14z'
          }, {
            text: 'Coaching, Training & Public Speaking Certificat Maxwell Leadership',
            why: 'Îți formez liderii ca să conducă ei echipa, ca să nu mai fii tu singurul care ia decizii și singurul care ține compania în picioare.',
            icon: 'M19 20H5a2 2 0 01-2-2V6a2 2 0 012-2h10a2 2 0 012 2v1m2 13a2 2 0 01-2-2V7m2 13a2 2 0 002-2V9a2 2 0 00-2-2h-2m-4-3H9M7 16h6M7 8h6v4H7V8z'
          }, {
            text: 'Certificare DISC — Profilare Comportamentală și Leadership',
            why: 'Îți arăt negru pe alb de ce anumiți oameni din echipă nu se înțeleg și cine e potrivit pentru ce rol, ca să nu mai angajezi și să nu mai promovezi din intuiție.',
            icon: 'M9 12l2 2 4-4m5.618-4.016A11.955 11.955 0 0112 2.944a11.955 11.955 0 01-8.618 3.04A12.02 12.02 0 003 9c0 5.591 3.824 10.29 9 11.622 5.176-1.332 9-6.03 9-11.622 0-1.042-.133-2.052-.382-3.016z'
          }, {
            text: '12 Ani de Implementare Sisteme de Conducere pentru Companii Românești',
            why: 'Am văzut deja unde se blochează o companie ca a ta, așa că îți dau soluția testată pe teren în România, nu teorie tradusă dintr-o carte americană.',
            icon: 'M21 13.255A23.931 23.931 0 0112 15c-3.183 0-6.22-.62-9-1.745M16 6V4a2 2 0 00-2-2h-4a2 2 0 00-2 2v2m4 6h.01M5 20h14a2 2 0 002-2V8a2 2 0 00-2-2H5a2 2 0 00-2 2v10a2 2 0 002 2z'
          }, {
            text: 'Fondator și Antreprenor cu Exit de Milioane EUR',
            why: 'Am trecut eu însumi prin haos, delegare și vânzarea companiei, deci înțeleg presiunea deciziilor tale și știu ce trebuie documentat ca afacerea să valoreze ceva fără tine.',
            icon: 'M13 7h8m0 0v8m0-8l-8 8-4-4-6 6'
          }].map((cert, i) => <div key={i} className="bg-[#0A1628] rounded-2xl p-6 flex items-start gap-6 border border-[rgba(255,255,255,0.1)] w-full" data-id="element-223" data-mp="1zdb8sqqtdn93" data-mpi={i}>
                <div className="w-12 h-12 rounded-full bg-[rgba(59,130,246,0.2)] flex items-center justify-center flex-shrink-0 text-[#3B82F6]" data-id="element-224" data-mp="1ufrp3bbcki9r">
                  <svg className="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24" data-id="element-225" data-mp="gui7wf2z67">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d={cert.icon} data-id="element-226" data-mp="3cdzno3b70efe" />
                  </svg>
                </div>
                <div data-id="element-227" data-mp="37e4vzxjlfkta">
                  <p className="font-['Montserrat'] text-[16px] font-semibold text-white mb-1.5" data-id="element-228" data-mp="37dlcwdi7iqdo">
                    {cert.text}
                  </p>
                  <p className="font-['Inter'] text-[15px] font-light text-[rgba(255,255,255,0.65)] leading-[1.65]" data-id="element-229" data-mp="2yezxusby1thn">
                    {cert.why}
                  </p>
                </div>
              </div>)}
          </div>
        </div>
      </section>

      {/* SECTION 7 — CTA FINAL */}
      <FooterCTA title="Compania ta merită să funcționeze fără să fii tu prezent în fiecare zi." subtitle="Rezervă o sesiune de diagnostic gratuit. În 60 de minute analizăm împreună situația reală a afacerii tale și îți spun exact ce lipsește și care e primul pas concret." buttonText="Rezervă Diagnosticarea Gratuită" data-id="element-230" data-mp="3mbnhmr0z5hwi" />
    </div>;
}